import { CalendarEvent, CalendarView, CalendarWeekViewBeforeRenderEvent } from 'angular-calendar';
import { Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeUrl, SafeResourceUrl } from '@angular/platform-browser';
import { FormBuilder, FormGroup, FormsModule } from '@angular/forms';
import { Subject, reduce, takeUntil } from 'rxjs';
import { addDays, differenceInMinutes, startOfDay, startOfHour, subDays, subWeeks } from 'date-fns';

import { AddCalendarDialogComponent } from './add-calendar-dialog/add-calendar-dialog.component';
import { CancelAppointmentDialogComponent } from './cancel-appointment-dialog/cancel-appointment-dialog.component';
import { AuthService } from '../../core/services/auth.service';
import { ChangeDetectorRef } from '@angular/core';
import { ConfirmDialogComponent } from '../../shared/confirm-dialog/confirm-dialog.component';
import { DataService } from 'src/app/core/services/data.service';
import { CommonModule, DatePipe } from '@angular/common';
import { DeleteConfirmComponent } from '../notifications/delete-confirm/delete-confirm.component';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { StorageserviceService } from '../../core/services/storageservice.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { InvoicePdfViewerComponent } from '../invoice-pdf-viewer/invoice-pdf-viewer.component';

import { DoctorSearchComponent } from './doctor-search/doctor-search.component';
import { DoctorDialogComponent } from './doctor-dialog/doctor-dialog.component';
import { Doctor, DoctorService } from '../../core/services/doctor.service';
import { finalize } from 'rxjs/operators'; // add to your rxjs imports

interface Appointment {
  id: number;
  lawyerName: string;
  lawyerInitials: string;
  specialization: string;
  status: 'Upcoming' | 'Completed';
  subStatus: 'Instant' | 'Scheduled';
  dateTime: string;
  note?: string;
  type?: 'Instant' | 'Scheduled';
}

@Component({
  selector: 'app-appointments',
  imports: [
    CommonModule,
    FormsModule,
    MatMenuModule,
    MatTableModule,
    MatTooltipModule,
    InvoicePdfViewerComponent,
    DoctorSearchComponent
  ],
  templateUrl: './appointments.component.html',
  styleUrl: './appointments.component.css',
})
export class AppointmentsComponent implements OnInit, OnDestroy {

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    const target = event.target as HTMLElement;
    if (!target.closest('.dropdown-wrapper')) {
      this.showStatusDropdown = false;
      this.showOrderDropdown = false;
    }
  }

  currentTime = new Date();
  appointments: any[] = [];
  filteredAppointments: any[] = [];
  searchQuery = ''; // This is the search input
  sortBy = '';
  viewApp = false;
  viewMode: 'grid' | 'list' = 'grid';
  
  displayedColumns: string[] = ['lawyer', 'datetime', 'features', 'status', 'actions'];
  pageIndex = 0;
  pageSize = 10;
  pagedAppointments: any[] = [];
  Math = Math;
  activeTab: string = 'personal';
  selectedAppointment: any;
  viewAppointments: any;

  // ── Invoice viewer state (shared invoice-pdf-viewer component) ──────────
  isInvoicePreviewOpen = false;
  isInvoicePreviewLoading = false;
  invoicePreviewUrl: SafeResourceUrl | null = null;
  invoiceTitle = 'Invoice';
  private invoiceRequestInFlight = false;
  ownerJID = localStorage.getItem("jid")  
  domain = environment.xmppDomain

  statusOptions = ['All Status', 'Upcoming', 'Completed', 'Cancelled'];
  statusFilter = 'All Status';

  orderFilter = 'Latest First';
  orderOptions = ['Latest First', 'Oldest First', 'By Name'];

  showStatusDropdown = false;
  showOrderDropdown = false;

  upcomingAppointments: any[] = [];
  otherAppointments: any[] = [];

  isJoinEnabled: boolean = false;
  joinTooltip: string = '';
  timerInterval: any;
  appId:any;
  checkstatus:any;

  // ── Offer Banner ────────────────────────────────────────────────────────
  // API: { offers: [{ offer_name, offer_text, start_date, end_date, coupon_code }] }
  showOfferBanner = false;
  offerBannerData: {
    title: string;        // ← offer_name
    description: string;  // ← offer_text
    discount: string;     // ← "Use code <coupon_code>"
    cta_url: string;
    offer_type: string;
    end_time: string | null;  // ← end_date
    is_active: boolean;
  } | null = null;
  // isMultiDay=true  → more than 24 h remain → show "X days left"
  // isMultiDay=false → within 24 h            → show HH : MM : SS
  bannerCountdown: {
    hours: string;
    minutes: string;
    seconds: string;
    days: number;         // whole days remaining
    isMultiDay: boolean;  // true when remaining > 24 h
  } = { hours: '00', minutes: '00', seconds: '00', days: 0, isMultiDay: false };
  private bannerTimerIntervalId: any;
  private bannerEndTime!: number;

  // ── T&C ──────────────────────────────────────────────────────────────────
  showTermsModal: boolean = false;
  isChecked: boolean = false;
  termsUrl: string = '';
  termsVersion: string = '';
  safeTermsUrl: any;
  profileImg: string = '';
  pageLoader = true;   
  bookingDoctorLoading = false;  

  constructor(
    private dialog: MatDialog, private datePipe: DatePipe, private http: HttpClient,
    private sanitizer: DomSanitizer, private cdr: ChangeDetectorRef,
    private storageService: StorageserviceService,
    private fb: FormBuilder, private auth: AuthService, private data: DataService, 
    private router: Router, private toastr: ToastrService, private doctors: DoctorService,
  ) { }

  ngOnInit() {
    // T&C: Check acceptance flag set during login
    // const termAccept = localStorage.getItem('requiresTermsAcceptance');
    // if (termAccept === 'true') {
    //   this.openTermsDialog();
    // }

    this.viewApp = false;
    this.auth.get_image().subscribe({
        next: (res: any) => {
          this.profileImg = res?.data?.imageUrl || '';
        },
        error: () => {
          // Fail silently — avatar initial letter will show as fallback
          this.profileImg = '';
        }
      });
    this.fetchAppointments();
    this.updatePagedData();
    this.getBannerData();
  }

  fetchAppointments(): void {
    this.pageLoader = true;
    this.auth.getAppointments().subscribe((res: any) => {
      this.pageLoader = false;
      this.appointments = res.appointments;
      //console.log('✅ Fetched appointments:', this.appointments);
      
      // if (this.appointments && this.appointments.length > 0) {
      //  // console.log('📋 First appointment structure:', this.appointments[0]);
      //  // console.log('📋 Available fields:', Object.keys(this.appointments[0]));
      // }
      
      this.separateAppointments();
      this.filterAppointments();
    });
  }

  updatePagedAppointments() {
  const start = this.pageIndex * this.pageSize;
  const end = start + this.pageSize;

  this.pagedAppointments = this.filteredAppointments.slice(start, end);
}

  // Upcoming cards respect the search box (replaces the old non-standalone FilterPipe)
  get filteredUpcomingAppointments(): any[] {
    const query = (this.searchQuery || '').toLowerCase().trim();
    if (!query) return this.upcomingAppointments;
    return this.upcomingAppointments.filter(app =>
      [app.lawyer_name,
       Array.isArray(app.specialization) ? app.specialization.join(' ') : app.specialization,
       app.appointment_type, app.ui_status, app.appointment_status, app.id]
        .some(v => (v || '').toString().toLowerCase().includes(query))
    );
  }

  separateAppointments(): void {
    const now = new Date();
    
    // this.upcomingAppointments = this.appointments.filter(app => {
    //   if (app.ui_status === 'upcoming' || app.ui_status === 'payment_pending') {
    //     const appointmentDate = new Date(app.appointment_start_at);
    //     return appointmentDate >= now;
    //   }
    //   return false;
    // }).sort((a, b) => {
    //   return new Date(a.appointment_start_at).getTime() - new Date(b.appointment_start_at).getTime();
    // });
    this.upcomingAppointments = this.appointments
  .filter(app =>
    ['ongoing', 'upcoming'].includes(app.ui_status)
  )
  .sort((a, b) => {
    // ongoing first
    if (a.ui_status === 'ongoing' && b.ui_status !== 'ongoing') return -1;
    if (a.ui_status !== 'ongoing' && b.ui_status === 'ongoing') return 1;

    return (
      new Date(a.appointment_start_at).getTime() -
      new Date(b.appointment_start_at).getTime()
    );
  });

    this.otherAppointments = this.appointments.filter(app => 
      !this.upcomingAppointments.includes(app)
    );

    console.log('📊 Upcoming appointments:', this.upcomingAppointments);
    console.log('📊 Other appointments:', this.otherAppointments);
  }

  toggleStatus(event: Event) {
    event.stopPropagation();
    this.showStatusDropdown = !this.showStatusDropdown;
    this.showOrderDropdown = false;
  }

  toggleOrder(event: Event) {
    event.stopPropagation();
    this.showOrderDropdown = !this.showOrderDropdown;
    this.showStatusDropdown = false;
  }

  selectStatus(status: string, event: Event) {
    event.stopPropagation();
    this.statusFilter = status;
    this.showStatusDropdown = false;
    console.log('🔍 Status filter changed to:', status);
    this.filterAppointments();
  }

  selectOrder(order: string, event: Event) {
    event.stopPropagation();
    this.orderFilter = order;
    this.showOrderDropdown = false;
    console.log('🔍 Order filter changed to:', order);
    this.filterAppointments();
  }

  onStatusChange(status: string): void {
    this.statusFilter = status;
    this.filterAppointments();
  }

  onOrderChange(order: string): void {
    this.orderFilter = order;
    this.filterAppointments();
  }

  // FIXED SEARCH FUNCTIONALITY
  filterAppointments(): void {
    // console.log('\n ===== FILTERING START =====');
    // console.log('Search Query:', `"${this.searchQuery}"`);
    // console.log('Status Filter:', this.statusFilter);
    // console.log('Order Filter:', this.orderFilter);
    // console.log('View Mode:', this.viewMode);

    let data: any[] = [];

    if (this.viewMode === 'grid') {
      data = [...this.otherAppointments];   // grid
    }
    else if (this.viewMode === 'list') {
      data = [...this.appointments];        // list
    }

    //console.log('📊 Starting with other appointments:', data.length);

    // ============================================
    // SEARCH FILTER - FIXED
    // ============================================
    if (this.searchQuery && this.searchQuery.trim() !== '') {
      const query = this.searchQuery.toLowerCase().trim();
      //console.log('🔎 Applying search for:', `"${query}"`);
      
      const beforeCount = data.length;
      
      data = data.filter(app => {
        // Lawyer name from API response
        const lawyerName = (app.lawyer_name || '').toLowerCase();
        
        // Specialization is an array in API response
        const specialization = Array.isArray(app.specialization) 
          ? app.specialization.join(' ').toLowerCase()
          : '';
        
        // Appointment type from API
        const appointmentType = (app.appointment_type || '').toLowerCase();
        
        // Status fields from API
        const uiStatus = (app.ui_status || '').toLowerCase();
        const appointmentStatus = (app.appointment_status || '').toLowerCase();
        
        // Also search by appointment ID
        const appointmentId = (app.id || '').toLowerCase();
        
        const matches = 
          lawyerName.includes(query) ||
          specialization.includes(query) ||
          appointmentType.includes(query) ||
          uiStatus.includes(query) ||
          appointmentStatus.includes(query) ||
          appointmentId.includes(query);
        
        if (matches) {
          console.log('✅ Match found:', {
            lawyerName,
            specialization,
            type: appointmentType
          });
        }
        
        return matches;
      });
      
      //console.log(`🔎 Search results: ${beforeCount} → ${data.length} appointments`);
      
      if (data.length === 0) {
        //console.log('⚠️ No matches found for search query:', query);
      }
    }

    // ============================================
    // STATUS FILTER
    // ============================================
    if (this.statusFilter !== 'All Status') {
      console.log('🏷️ Applying status filter:', this.statusFilter);
      const beforeCount = data.length;
      
      data = data.filter(app => {
        const uiStatus = app.ui_status?.toLowerCase();
        const appointmentStatus = app.appointment_status?.toLowerCase();
        
        let matches = false;
        
        switch (this.statusFilter) {
          case 'Upcoming':
            matches = uiStatus === 'upcoming' || uiStatus === 'payment_pending';
            break;
          
          case 'Completed':
            matches = uiStatus === 'completed' || appointmentStatus === 'completed';
            break;
          
          case 'Cancelled':
            matches = uiStatus === 'cancelled' || appointmentStatus === 'cancelled';
            break;
          
          default:
            matches = true;
        }
        
        return matches;
      });
      
      console.log(`🏷️ Status filter results: ${beforeCount} → ${data.length} appointments`);
    }

    // ============================================
    // SORTING
    // ============================================
    console.log('🔀 Applying sort:', this.orderFilter);
    
    const sortData = (a: any, b: any) => {
  // Ongoing appointments always first
  if (a.ui_status === 'ongoing' && b.ui_status !== 'ongoing') {
    return -1;
  }

  if (a.ui_status !== 'ongoing' && b.ui_status === 'ongoing') {
    return 1;
  }

  // Existing sorting
  switch (this.orderFilter) {
    case 'Latest First':
      return (
        new Date(b.appointment_start_at || b.created_at || 0).getTime() -
        new Date(a.appointment_start_at || a.created_at || 0).getTime()
      );

    case 'Oldest First':
      return (
        new Date(a.appointment_start_at || a.created_at || 0).getTime() -
        new Date(b.appointment_start_at || b.created_at || 0).getTime()
      );

    case 'By Name':
      return (a.lawyer_name || '').localeCompare(b.lawyer_name || '');

    default:
      return 0;
  }
};

data.sort(sortData);

    // switch (this.orderFilter) {
    //   case 'Latest First':
    //     data.sort((a, b) => {
    //       const dateA = new Date(a.appointment_start_at || a.created_at || a.dateTime || 0).getTime();
    //       const dateB = new Date(b.appointment_start_at || b.created_at || b.dateTime || 0).getTime();
    //       return dateB - dateA;
    //     });
    //     break;

    //   case 'Oldest First':
    //     data.sort((a, b) => {
    //       const dateA = new Date(a.appointment_start_at || a.created_at || a.dateTime || 0).getTime();
    //       const dateB = new Date(b.appointment_start_at || b.created_at || b.dateTime || 0).getTime();
    //       return dateA - dateB;
    //     });
    //     break;

    //   case 'By Name':
    //     data.sort((a, b) => {
    //       const nameA = (a.lawyer_name || '').toLowerCase();
    //       const nameB = (b.lawyer_name || '').toLowerCase();
    //       return nameA.localeCompare(nameB);
    //     });
    //     break;
    // }

    this.filteredAppointments = data;
    console.log('✅ Final filtered count:', this.filteredAppointments.length);
    console.log('🔍 ===== FILTERING END =====\n');
    
    this.pageIndex = 0;
    this.updatePagedData();
  }

  onSearchChange(): void {
    console.log('⌨️ Search input changed to:', `"${this.searchQuery}"`);
    this.filterAppointments();
  }

  bookApp() {
    this.router.navigate(['/consumer']);
  }  
  
  bookAppNew() {
    this.router.navigate(['/consumer']);
  }
    // ── Doctor search → details / slots / billing / confirmation dialog ──────
  openDoctorDialog(doctor: Doctor): void {
    const ref = this.dialog.open(DoctorDialogComponent, {
      width: '860px',
      maxWidth: '96vw',
      panelClass: 'doctor-dialog-panel',
      autoFocus: false,
      data: { doctor },
    });

    ref.afterClosed().subscribe(res => {
      if (res?.booked) {
        this.fetchAppointments();   // refresh list after a successful booking
      }
    });
  }
    
  // isSubActive comes from the appointments API; only an explicit false means expired.
  isLawyerInactive(appointment: any): boolean {
    return appointment?.isSubActive === false;
  }

  inactiveLawyerTip(appointment: any): string {
    return `Lawyer ${appointment?.lawyer_name || ''} is no longer accepting appointments. Click on "Find Lawyers" to find another lawyer.`;
  }

  chatUnavailableTip(appointment: any): string {
    return `Chat window with Lawyer ${appointment?.lawyer_name || ''} is no longer available. Please try after some time.`;
  }

  goFindLawyer(): void {
    this.router.navigate(['/consumer/search-results']);
  }

  // goBookSlotFromAppointment(appointment: any) {
  //   if (this.isLawyerInactive(appointment)) return;
  //   const lawyerId = appointment.lawyer_id || appointment.guid;

  //   // Use 'category' field from API: 'entity' = firm-lawyer, 'solo' = independent lawyer
  //   const isEntityLawyer = appointment.category === 'entity';
  //   const firmId = appointment.firm_id;
  //   // const isEntityLawyer = true; 

  //   if (isEntityLawyer && firmId) {
  //     // Firm-lawyer → navigate to firm-details (route: /firm/:id), lawyers tab, auto-expand this lawyer
  //     console.log('[Calendar] Routing to firm/:id for firm:', firmId, 'lawyer:', lawyerId);
  //     this.router.navigate(['/consumer/firm', firmId], {
  //       queryParams: {
  //         tab:            'lawyers',
  //         expandLawyerId: lawyerId
  //       }
  //     });
  //   } else {
  //     // Solo lawyer → existing bookslot flow unchanged
  //     console.log('[Calendar] Routing to bookslot for solo lawyer:', lawyerId);
  //     this.router.navigate(['/consumer/bookslot'], {
  //       state: {
  //         lawyerId: lawyerId
  //       }
  //     });
  //   }
  // }
  goBookSlotFromAppointment(appointment: any): void {
    
  console.log('appointment used:', appointment);
  this.pageLoader = true; //loads

  if (this.isLawyerInactive(appointment) || this.bookingDoctorLoading) return;

  // Doctor code like "DR-W5SEJK", the same value lookupDoctor() takes in DoctorSearchComponent
  const code = appointment?.doctor_code || appointment?.lawyer_code || appointment?.lawyer_id || appointment?.guid;
  if (!code) {
    this.toastr.error('Unable to open doctor: missing doctor code.');
    return;
  }

    const raw = String(code);
    const lookupCode = raw.toUpperCase().startsWith('DR-') ? raw.toUpperCase() : raw;

    this.bookingDoctorLoading = true;
    this.pageLoader = true;
    this.doctors.lookupDoctor(lookupCode)
      .pipe(finalize(() => (this.bookingDoctorLoading = false, this.pageLoader = false)))
      .subscribe({next: (doctor) => {
        if (!doctor) { this.toastr.error('Doctor details could not be found.'); return; }

        const apptSpecs: string[] = Array.isArray(appointment.specialization)
          ? appointment.specialization : [];
        const specs = doctor.specializations?.length ? doctor.specializations : apptSpecs;

        this.openDoctorDialog({
          ...doctor,
          doctor_code: doctor.doctor_code || appointment.doctor_code || '',  // never show the Mongo ID
          name: doctor.name || appointment.lawyer_name,
          specializations: specs,
          specialty: doctor.specialty || specs[0] || '',
        });
      },
      error: () => this.toastr.error('Could not load doctor details. Please try again.'),
    });
}

  viewAppDetails(app: any) {
    console.log('Viewing appointment details for:', app);
    this.viewApp = true;
    this.appId = app.id;
    this.checkstatus = app.ui_status;
    console.log('Checking status for appointment:',this.checkstatus)

    this.auth.viewAppointment(app?.id).subscribe((res: any) => {
      this.viewAppointments = res?.appointment;
      if (!this.viewAppointments.appointment_start_at && this.viewAppointments.appointment_from) {
        this.viewAppointments.appointment_start_at = this.viewAppointments.appointment_from;
      }
      this.checkJoinAvailability();
      this.startJoinTimer(); // 🔥 auto re-check every 30 sec
    });
  }

  checkJoinAvailability() {

    if (!this.viewAppointments?.appointment_from) {
      this.isJoinEnabled = false;
      return;
    }

    const appointmentTime = new Date(this.viewAppointments.appointment_from).getTime();
    const currentTime = new Date().getTime();

    const oneMinuteBefore = appointmentTime - (60 * 1000);

    if (
      this.viewAppointments.ui_status === 'upcoming' || this.viewAppointments.appointment_status === 'upcoming' &&
      currentTime >= oneMinuteBefore
    ) {
      this.isJoinEnabled = true;
      this.joinTooltip = '';
    } else {
      this.isJoinEnabled = false;
      this.joinTooltip = 'You can join 1 minute before the appointment';
    }
  }

  // Per-appointment join availability (used by the list/grid cards and menus,
  // each of which represents a different appointment) — unlike isJoinEnabled
  // above, which only reflects whichever single appointment was last opened
  // via viewAppDetails(), this checks the given appointment's own start time
  // so every card/row is enabled/disabled independently and correctly.
  canJoinCall(appointment: any): boolean {
    if (!appointment) {
      return false;
    }
    if (appointment.ui_status !== 'upcoming') {
      // Only the 'upcoming' state is time-gated; other states (e.g. 'ongoing')
      // keep their existing enabled behaviour.
      return true;
    }
    const startTime = appointment.appointment_start_at || appointment.appointment_from;
    if (!startTime) {
      return false;
    }
    const appointmentTime = new Date(startTime).getTime();
    const oneMinuteBefore = appointmentTime - (60 * 1000);
    return new Date().getTime() >= oneMinuteBefore;
  }
  startJoinTimer() {
    // Clear any previously running timer before starting a new one —
    // viewAppDetails() can be called multiple times (switching between appointments)
    // and each call would stack a new interval on top without this guard.
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
    this.timerInterval = setInterval(() => {
      this.checkJoinAvailability();
    }, 30000); // check every 30 seconds
  }
  ngOnDestroy() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
    clearInterval(this.bannerTimerIntervalId);
  }

  goBack() {
    this.viewApp = false;
    this.fetchAppointments();
  }

  setViewMode(mode: 'grid' | 'list') {
    this.viewMode = mode;
    this.filterAppointments();
    
    if (mode === 'list') {
      this.updatePagedAppointments();
    }
  }

  updatePagedData() {
    const start = this.pageIndex * this.pageSize;
    const end = start + this.pageSize;
    this.pagedAppointments = this.filteredAppointments.slice(start, end);
    // console.log('📄 Page updated:', {
    //   pageIndex: this.pageIndex,
    //   pageSize: this.pageSize,
    //   showing: this.pagedAppointments.length,
    //   total: this.filteredAppointments.length
    // });
  }

  nextPage() {
    if ((this.pageIndex + 1) * this.pageSize < this.filteredAppointments.length) {
      this.pageIndex++;
      this.updatePagedData();
    }
  }

  prevPage() {
    if (this.pageIndex > 0) {
      this.pageIndex--;
      this.updatePagedData();
    }
  }
  
  get endIndex(): number {
    return Math.min((this.pageIndex + 1) * this.pageSize, this.filteredAppointments.length);
  }

  setActiveTab(tab: string) {
    this.activeTab = tab;
  }

  goChat() {
    this.router.navigate(['/chats']);
  }

  goChatApp(appointment: any) {
    if (this.isLawyerInactive(appointment)) {
      return;
    }
    console.log('💬 Opening chat for appointment:', appointment);
    // `category` field from the API: 'entity' = firm-lawyer, 'solo' = independent.
    // Guard: fall back to `type` field if `category` is absent.
    const appointmentType = appointment.category || appointment.type || '';
    this.router.navigate(['/consumer/chats'], {
      queryParams: {
        guid:      appointment.guid      || '',
        type:      appointmentType,
        firm_id:   appointment.firm_id   || '',
        lawyer_id: appointment.lawyer_id || '',
      }
    });
  }

  goPayment() {
    this.router.navigate(['/appointments/payment'], {

    });
  }

   goAppointmentHistory(appointment: any): void {
    this.router.navigate(['/appointments/history'], {
      state: {
        lawyerId:         appointment.lawyer_id || appointment.guid || '',
        lawyerName:       appointment.lawyer_name       || '',
        lawyerProfilePic: appointment.profilepic_url    || '',
      }
    });
  }

  cancelApp(app: any): void {
    const dialogRef = this.dialog.open(CancelAppointmentDialogComponent, {
      width: '480px',
      maxWidth: '96vw',
      panelClass: 'cancel-appointment-dialog-panel',
      data: { appointmentId: app.id }
    });

    dialogRef.afterClosed().subscribe((confirmed) => {
      if (confirmed) {
        this.toastr.success('Appointment cancelled successfully.');
        this.fetchAppointments();
      }
    });
  }

  deleteApp(app: any): void {
    console.log('Attempting to delete appointment:', app);
    const dialogRef = this.dialog.open(DeleteConfirmComponent, {
      width: '400px',
      //data: { id: app.id }
      data: { id: app.id, message: `Are you sure you want to delete this appointment?` }
    });

    dialogRef.afterClosed().subscribe((confirmed) => {
      if (confirmed) {
        this.auth.dellogAppointment(app.id).subscribe({
          next: (res: any) => {
            if (res && res.error === false) {
              this.toastr.success(res.msg);
                 this.fetchAppointments();
                 this.updatePagedData();
            }
          },
          error: (err) => {
            const message = err?.error?.msg || 'Cancellation failed';
            this.toastr.error(message);
          }
        });
      }
    });
  }

  // ── View Invoice (Appointments) ──────────────────────────────────────────
  // Calls the shared AuthService.viewInvoice() with the clicked appointment's
  // own `id` (never lawyer_id/firm_id/guid/meeting_room_id), then opens the
  // shared invoice PDF viewer. Mirrors the Documents module's existing
  // loading/error/toast conventions.
  viewInvoice(app: any): void {
    if (!app?.id) {
      this.toastr.error('Unable to view invoice: missing appointment id.');
      return;
    }
    if (this.invoiceRequestInFlight) {
      return; // guard against duplicate/rapid clicks
    }

    this.invoiceRequestInFlight = true;
    this.invoiceTitle = `Invoice - ${app.lawyer_name || ''}`.trim();
    this.invoicePreviewUrl = null;
    this.isInvoicePreviewOpen = true;
    this.isInvoicePreviewLoading = true;

    this.auth.viewInvoice(app.id, 'view').subscribe({
      next: (res: any) => {
        this.invoiceRequestInFlight = false;
        this.isInvoicePreviewLoading = false;

        // Backend contract: prefer a JSON { error:false, data:{ url } } response,
        // matching the existing Documents download convention. Fall back to a
        // few other shapes defensively without assuming one blindly.
        const pdfUrl = res?.data?.url || res?.url || (typeof res === 'string' ? res : null);

        if (res?.error || !pdfUrl) {
          this.isInvoicePreviewOpen = false;
          this.toastr.error(res?.msg || 'Failed to load invoice.');
          return;
        }

        this.invoicePreviewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(pdfUrl);
      },
      error: (err) => {
        this.invoiceRequestInFlight = false;
        this.isInvoicePreviewLoading = false;
        this.isInvoicePreviewOpen = false;
        const message = err?.error?.msg || 'Failed to load invoice.';
        this.toastr.error(message);
      }
    });
  }

  closeInvoicePreview(): void {
    this.isInvoicePreviewOpen = false;
    this.isInvoicePreviewLoading = false;
    this.invoicePreviewUrl = null;
  }

  getViewApplog() {
    this.auth.viewAppointment(this.appId).subscribe((res: any) => {
      this.viewAppointments = res?.appointment;
      if (!this.viewAppointments.appointment_start_at && this.viewAppointments.appointment_from) {
        this.viewAppointments.appointment_start_at = this.viewAppointments.appointment_from;
      }
      this.checkJoinAvailability();
      this.startJoinTimer(); // 🔥 auto re-check every 30 sec
    });
  }

  preventLeadingSpace(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    const isFirstChar = input.selectionStart === 0;
    if (event.key === ' ' && isFirstChar) {
      event.preventDefault();
    }
  }

  formatSlots(slots: any[]): string {
    if (!slots || !slots.length) {
      return 'Not Available';
    }

    return slots
      .map(slot =>
        `${this.formatTime(slot.start_time)} - ${this.formatTime(slot.end_time)}`
      )
      .join(', ');
  }

  formatTime(time: string): string {
    const [hour, minute] = time.split(':');
    const h = +hour % 12 || 12;
    const ampm = +hour >= 12 ? 'PM' : 'AM';
    return `${h}:${minute} ${ampm}`;
  }

  StartVideo(app: any) {
    console.log('📹 Starting video for:', app);
    let jid = this.ownerJID + "@" + this.domain;
    let token = localStorage.getItem('TOKEN');
    let firstName = localStorage.getItem('first_name') || '';
    let lastName = localStorage.getItem('last_name') || '';
    let name = `${firstName} ${lastName}`.trim();

    const start = app.appointment_start_at;
    const end = app.meeting_room_expires_at;

    const fromTime = this.formatTimes(start);
    const toTime = this.formatTimes(end);
    const date = this.formatDate(start);
    const fullname = localStorage.getItem('full_name')

    const link = `${environment.AVChat}join-room?roomId=${app.meeting_room_id}&name=${fullname}&fromTime=${fromTime}&toTime=${toTime}&date=${date}`;
    window.open(link);
  }

  formatTimes(dateStr: string): string {
    const d = new Date(dateStr);
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  formatDate(dateStr: string): string {
    const d = new Date(dateStr);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  // ── Offer Banner Methods ───────────────────────────────────────────────
  /**
   * Fetches banner from GET {{admin_base_url}}/banners?offer_type=client
   * Shows banner and starts countdown only when is_active = true.
   */
  getBannerData(): void {
    // API response: { offers: [{ offer_name, offer_text, start_date, end_date, coupon_code }] }
    this.auth.getBannerData().subscribe({
      next: (res: any) => {
        const offers: any[] = res?.offers || [];

        // Show the first offer returned — the backend already
        // filters inactive offers before responding.
        const activeOffer = offers.length > 0 ? offers[0] : null;

        if (activeOffer) {
          this.offerBannerData = {
            title:       activeOffer.offer_name  || '',
            description: activeOffer.offer_text  || '',
            discount:    activeOffer.coupon_code
                           ? `Use code ${activeOffer.coupon_code}`
                           : '50% OFF',
            cta_url:     activeOffer.cta_url     || '',
            offer_type:  'client',
            end_time:    activeOffer.end_date     || null,
            is_active:   true,
          };

          // Countdown to end_date; fall back to 2 h 5 m 30 s from now
          this.bannerEndTime = activeOffer.end_date
            ? new Date(activeOffer.end_date).getTime()
            : Date.now() + (2 * 3600 + 5 * 60 + 30) * 1000;

          this.showOfferBanner = true;
          this.startBannerCountdown();
        } else {
          this.showOfferBanner = false;
        }
      },
      error: (err: any) => {
        console.error('[CalendarComponent] Banner API error:', err);
        this.showOfferBanner = false;
      }
    });
  }

  startBannerCountdown(): void {
    const pad = (n: number) => String(n).padStart(2, '0');
    const ONE_DAY_MS = 24 * 3600 * 1000;

    const tick = () => {
      const remaining = Math.max(0, this.bannerEndTime - Date.now());

      if (remaining > ONE_DAY_MS) {
        // ── Multi-day mode: show whole days remaining ──────────────────
        const days = Math.ceil(remaining / ONE_DAY_MS);
        this.bannerCountdown = {
          hours: '00', minutes: '00', seconds: '00',
          days,
          isMultiDay: true,
        };
      } else {
        // ── Same-day mode: show HH : MM : SS ──────────────────────────
        const h = Math.floor(remaining / 3600000);
        const m = Math.floor((remaining % 3600000) / 60000);
        const s = Math.floor((remaining % 60000) / 1000);
        this.bannerCountdown = {
          hours: pad(h), minutes: pad(m), seconds: pad(s),
          days: 0,
          isMultiDay: false,
        };
      }

      if (remaining === 0) {
        clearInterval(this.bannerTimerIntervalId);
        this.showOfferBanner = false;
      }
    };

    tick(); // run immediately so display is correct before first interval fires
    this.bannerTimerIntervalId = setInterval(tick, 1000);
  }

  closeOfferBanner(): void {
    this.showOfferBanner = false;
    clearInterval(this.bannerTimerIntervalId);
  }

  onClaimOffer(): void {
    if (this.offerBannerData?.cta_url) {
      window.open(this.offerBannerData.cta_url, '_blank', 'noopener,noreferrer');
    }
  }

  // ── T&C Methods ───────────────────────────────────────────────────────────
  // openTermsDialog(): void {
  //   this.showTermsModal = true;

  //   this.auth.getTerms().subscribe((res: any) => {
  //     this.termsUrl = res.data?.url;
  //     this.termsVersion = res.data?.version;

  //     if (this.termsUrl) {
  //       this.safeTermsUrl = this.sanitizer.bypassSecurityTrustResourceUrl( this.termsUrl);
  //       setTimeout(() => this.cdr.detectChanges());
  //     }
  //   });
  // }

  // agreeTerms(): void {
  //   if (!this.isChecked) return;

  //   this.auth.acceptTerms(this.termsVersion).subscribe({
  //     next: () => {
  //       this.showTermsModal = false;
  //       localStorage.setItem('requiresTermsAcceptance', 'false');
  //     },
  //     error: () => {
  //       this.toastr.error('Failed to accept Terms & Conditions. Please try again.', 'Error!');
  //     }
  //   });
  // }

  // cancelTerms(): void {
  //   this.router.navigate(['/consumer/login']);
  // }
  
  get showUpcomingSection(): boolean {
  return this.upcomingAppointments.length > 0 &&
    (this.statusFilter === 'All Status' || this.statusFilter === 'Upcoming');
}

get noVisibleAppointments(): boolean {
  const upcomingCount = this.showUpcomingSection ? this.filteredUpcomingAppointments.length : 0;
  return upcomingCount + this.filteredAppointments.length === 0;
}

get isFiltering(): boolean {
  return !!this.searchQuery?.trim() || this.statusFilter !== 'All Status';
}
}